import { useState } from "react";
import { useNavigate, useParams } from "router";
import { ValidationError, propertyCategoryMapper } from "./constants";
import { usePropertyCategoryValue } from "./propertyCategoryAtom";

export const usePropertyCategoryHandler = () => {
    const { lang } = useParams("/:lang/list-my-property/get-started/manual");
    const value = usePropertyCategoryValue();
    const navigate = useNavigate();
    const [error, setError] = useState<ValidationError>();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const onBack = () => {
        navigate("/:lang/list-my-property/get-started", {
            params: { lang },
        });
    };

    const onNext = () => {
        setError(undefined);
        try {
            switch (value) {
                case propertyCategoryMapper.Home:
                    return navigate("/:lang/list-my-property/get-started/home", {
                        params: { lang },
                    });
                case propertyCategoryMapper.Hotel:
                    return navigate("/:lang/list-my-property/get-started/hotel", {
                        params: { lang },
                    });
                case propertyCategoryMapper.Unique:
                    return navigate("/:lang/list-my-property/get-started/unique", {
                        params: { lang },
                    });
                default:
                    scrollToTop();
                    return setError(ValidationError.NotSelected);
            }
        } catch (e) {
            console.error(e);
            setError(ValidationError.Unknown);
        }
    };

    return { error, onBack, onNext };
};
